"use client";

import { getMatchDisplayTime } from "@/utils/matchInfo";

export default function KeoOddsMatchTime({ match, isLive, formattedDate, formattedGio, liveScore, statusNum }) {
  const displayTime = getMatchDisplayTime(liveScore, statusNum, match?.matchTime, match?.halfStartTime);

  return (
    <div className="flex flex-col items-center justify-center gap-1 py-1 border-r border-[var(--theme-border)]">
      {isLive ? (
        <>
          {displayTime.type === 'var' && (
            <>
              <span className="kbv-live-period-text text-[13px] font-bold">VAR</span>
            </>
          )}
          {displayTime.type === 'minute' && (
            <>
              <span className="kbv-live-period-text text-[13px] font-bold">{displayTime.halfLabel}</span>
              <span className="kbv-live-period-text text-xs" style={{ color: '#167dc7' }}>
                {displayTime.content} <span style={{ animation: "blink 1s infinite" }}>&apos;</span>
              </span>
            </>
          )}
          {displayTime.type === 'status' && (
            <span className="kbv-live-period-text text-[13px] font-bold">{displayTime.content}</span>
          )}
        </>
      ) : (
        <>
          <span className="text-[var(--theme-text)] text-xs font-bold">Sớm</span>
          <span className="text-[var(--theme-text)] text-xs font-normal">{formattedDate}</span>
          <span className="text-[var(--theme-text-muted)] text-xs font-normal">{formattedGio}</span>
        </>
      )}
    </div>
  );
}
